import React, { useState, useEffect, useContext } from "react";
import {
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MoonOutlined,
  SunOutlined,
  UserOutlined,
} from "@ant-design/icons"; //  BellOutlined, GlobalOutlined,   SettingOutlined,SearchOutlined,
import { Avatar, Button, Dropdown, Layout, Space, Modal } from "antd"; //  Badge,Breadcrumb,    Input,   Tag,   Typography,
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../services/authservice";
import { AuthContext } from "../services/authcontext";

const { Header } = Layout;

function HeaderBar({ collapsed, onToggle, mobile }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("theme") === "dark",
  );

  const { user } = useContext(AuthContext);

  const username = user?.username || "";

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.setAttribute("data-theme", "dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.removeAttribute("data-theme");
      localStorage.setItem("theme", "light");
    }
    // Added this line to instantly notify other components of the change
    window.dispatchEvent(new Event("themeChanged"));
  }, [isDarkMode]);

  /* const breadcrumbItems = location.pathname
    .split("/")
    .filter(Boolean)
    .map((segment, index, arr) => {
      const url = `/${arr.slice(0, index + 1).join("/")}`;
      const label = segment.charAt(0).toUpperCase() + segment.slice(1);

      return {
        title: (
          <span className="crumb-link" onClick={() => navigate(url)}>
            {label}
          </span>
        ),
      };
    });
 */
  const items = [
    {
      key: "profile",
      icon: <UserOutlined />,
      label: "Profile",
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      danger: true,
    },
  ];

  const { setIsAuthenticated } = useContext(AuthContext);

  const handleMenuClick = ({ key }) => {
    if (key === "profile") {
      navigate("/profile");
    } else if (key === "logout") {
      Modal.confirm({
        title: "Are you sure you want to log out?",
        content: "You will be redirected to the login page.",
        okText: "Yes, Log Out",
        cancelText: "Cancel",
        okButtonProps: {
          style: {
            backgroundColor: "#0D2E4D",
            borderColor: "#0D2E4D",
            color: "#fff",
          },
        },
        cancelButtonProps: {
          style: {
            backgroundColor: "#D97A07",
            borderColor: "#D97A07",
            color: "#fff",
          },
        },
        onOk: async () => {
          await AuthService.logout();
          setIsAuthenticated(false);
          navigate("/login", { replace: true });
        },
      });
    }
  };

  return (
    <Header className="app-header">
      <div className="header-main-row">
        <Space size={12} className="header-left">
          {mobile && (
            <img
              src={
                isDarkMode
                  ? "/img/majesteye-icon-skeye-gate-white.svg"
                  : "/img/majesteye-icon-skeye-gate.svg"
              }
              alt="SkeyeGate"
              style={{
                width: 28,
                height: 28,
                objectFit: "contain",
                cursor: "pointer",
              }}
              onClick={onToggle}
            />
          )}
          <Button
            type="text"
            className="trigger-btn"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={onToggle}
          />

          {/*           <Input
            className="header-search"
            size="large"
            placeholder="Search modules or datasets"
            prefix={<SearchOutlined />}
          /> */}
        </Space>

        <Space size={14} className="header-right">
          {/*           <Tag className="header-domain" icon={<GlobalOutlined />}>
            All Domains
          </Tag>
          <Tag className="header-domain">EN</Tag>
          <Badge count={2} size="small">
            <BellOutlined className="header-icon" />
          </Badge>
          <SettingOutlined className="header-icon" /> */}
          <Button
            type="text"
            onClick={() => setIsDarkMode(!isDarkMode)}
            icon={
              isDarkMode ? (
                <SunOutlined className="header-icon" />
              ) : (
                <MoonOutlined className="header-icon" />
              )
            }
          />
          <Dropdown
            menu={{ items, onClick: handleMenuClick }}
            trigger={["click"]}
          >
            <Space className="user-meta">
              <Avatar
                size={32}
                style={{ background: "#D97A07" }}
                icon={<UserOutlined />}
              />
              <span className="user-name">{username}</span>
            </Space>
          </Dropdown>
        </Space>
      </div>

      {/* <div className="breadcrumb-row">
        <Typography.Text className="breadcrumb-prefix">
          Navigation:
        </Typography.Text>
        <Breadcrumb
          items={
            breadcrumbItems.length
              ? breadcrumbItems
              : [
                  {
                    title: <span className="crumb-link">Home</span>,
                  },
                ]
          }
        />
      </div> */}
    </Header>
  );
}

export default HeaderBar;
